import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/appRoutes';
import { SearchProvider } from './context/SearchContext';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { ChatProvider } from './context/ChatContext';
import ChatManager from './components/chat/ChatManager';
import VersionChecker from './components/VersionChecker/VersionChecker';
import CookieBanner from './pages/landing/components/CookieBanner';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <SearchProvider>
        <AuthProvider>
          <CurrencyProvider>
            <ChatProvider>
              <ErrorBoundary>
                <VersionChecker />
                <CookieBanner />
                <AppRoutes />
                <ChatManager />
              </ErrorBoundary>
            </ChatProvider>
          </CurrencyProvider>
        </AuthProvider>
      </SearchProvider>
    </Router>
  );
}

export default App;